import { Button, Input } from '@app/components';
import { clsxm } from '@app/styles/clsxm';

import { DashboardPeriodPreset, useDashboardPeriod } from '../hooks/useDashboardPeriod';

const PRESETS: { value: DashboardPeriodPreset; label: string }[] = [
  { value: '1', label: 'Vandaag' },
  { value: '7', label: '7 dagen' },
  { value: '30', label: '30 dagen' },
  { value: '90', label: '90 dagen' },
];

// admin-dashboard-opdracht.md §4.0. Segmented look matches the mockup's .seg - deliberately
// more prominent than the plain dropdown pages/email/report/AdminEmailReportPage.tsx uses,
// since this selector drives the whole page, not one chart's granularity.
export const DashboardPeriodSelector: React.FC<ReturnType<typeof useDashboardPeriod>> = ({
  preset,
  from,
  to,
  setFrom,
  setTo,
  selectPreset,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="inline-flex overflow-hidden rounded-lg border border-gray-200 bg-white">
        {PRESETS.map((p) => (
          <button
            key={p.value}
            type="button"
            onClick={() => selectPreset(p.value)}
            className={clsxm(
              'px-3.5 py-1.5 text-[13px]',
              preset === p.value ? 'bg-[#132a4d] font-medium text-white' : 'text-gray-600 hover:bg-gray-50'
            )}
          >
            {p.label}
          </button>
        ))}
      </div>
      <Button
        variant="outlined"
        color="gray"
        size="small"
        onClick={() => selectPreset('custom')}
        className={clsxm(preset === 'custom' && 'border-[#132a4d]')}
      >
        Eigen bereik…
      </Button>
      {preset === 'custom' && (
        <div className="flex items-end gap-2">
          <Input label="Van" type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
          <Input label="Tot" type="date" value={to} onChange={(e) => setTo(e.target.value)} />
        </div>
      )}
    </div>
  );
};
